import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { AppCoreService } from '../../services/app-core.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
    resetPasswordForm: FormGroup;
    isFormSubmitted = false;
    hidePassword = true;
    hideconfirmpassword = true;
    year: number = new Date().getFullYear();
    useEnterKey: any;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private loginService: LoginService,
        private appCoreService: AppCoreService,
    ) {
        const navigation = this.router.getCurrentNavigation();
    }

    ngOnInit(): void {

        this.resetPasswordForm = this.formBuilder.group({
            txtPassword: [null, Validators.required],
            txtConfirmPassword: [null, Validators.required]
        }, { validators: this.matchPasswordValidator })

        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    matchPasswordValidator(control: FormGroup): { [key: string]: boolean } | null {
        const password = control.get('txtPassword')?.value;
        const confirmPassword = control.get('txtConfirmPassword')?.value;
        return password === confirmPassword ? null : { 'mismatch': true };
    }

    onFormSubmit() {
        this.isFormSubmitted = true;
        const userData: any = localStorage.getItem('ud');
        const tempUserData: any = typeof userData === 'object' ? userData : JSON.parse(userData);
        if (this.resetPasswordForm.valid) {
            const reqObj = {
                id: tempUserData?.userId,
                clientid: tempUserData?.clientId,
                emailid: tempUserData?.emailId,
                password: this.resetPasswordForm.get('txtPassword')?.value
            }

            this.loginService.ResetPassword(reqObj).subscribe((res) => {
                if (res && res.success) {
                    localStorage.removeItem('ud');
                    this.router.navigate(['/account/login']);
                }
            })
        }
    }
}